import React, {useEffect} from 'react';
import {Box, TablePagination} from "@mui/material";
import CustomSearch from "../components/common/CustomSearch";
import CustomSelect from "../components/common/CustomSelect";
import SearchComponent from "../components/searchComponent/SearchComponent";
import ReviewList from "../components/review/ReviewList";
import {useFormik} from "formik";
import {useAppDispatch, useTypedSelector} from "../store";
import {IGetFeedbacksFilter} from "../store/rtk-api/review/types";
import {clearQuery, clearQueryFilterData, setReviewFilterData} from "../store/review/review.slice";
import {grades, types} from "../components/common/helper";
import CustomDatePicker from "../components/common/CustomDatePicker";


const Review = () => {
    const dispatch = useAppDispatch()

    // Filter actions
    const {query, is_responded, star, created_date} = useTypedSelector(state => state.review)
    const formik = useFormik<IGetFeedbacksFilter>({
        enableReinitialize: true,
        initialValues: {
            query: query || '',
            is_responded: is_responded || 'all',
            star: star || 'all',
            created_date: created_date || 'all'
        },
        onSubmit: (values) => {
            dispatch(setReviewFilterData({
                page: undefined,
                query: values.query,
                is_responded: values.is_responded,
                star: values.star,
                created_date: values.created_date
            }))
        }
    })
    const {handleChange, values, handleSubmit, setFieldValue} = formik
    const handleClear = () => {
        dispatch(clearQueryFilterData())
        setFieldValue('query', '')
    }
    // Pagination actions
    const {feedbackCount} = useTypedSelector(state => state.calendar)
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    useEffect(() => {
        dispatch(setReviewFilterData({page: page + 1}))
        dispatch(clearQuery())
    }, [page])
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 20));
        setPage(0);
    };

    const children = (
        <Box sx={{display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%"}}>
            <div style={{display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                <div style={{marginRight: "20px"}}>
                    <CustomSearch field={"query"} handleChange={handleChange} placeholder={"Врач, услуга, процедура"}
                                  width={"300px"} name={"query"} values={values} handleSubmit={handleSubmit}
                                  handleClear={handleClear}/>
                </div>
                <div style={{marginRight: "10px"}}>
                    <CustomSelect handleChange={handleChange} width={"100px"} value={values.is_responded}
                                  name={"is_responded"} items={types} height={"40px"} handleSubmit={handleSubmit}/>
                </div>
                <div style={{marginRight: "20px"}}>
                    Оценка: <CustomSelect handleChange={handleChange} width={"80px"} value={values.star}
                                          name={"star"} items={grades} height={"40px"} handleSubmit={handleSubmit}/>
                </div>
                <div style={{
                    marginRight: "20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "5px"
                }}>
                    {/*<CustomSearch field={"date"} handleChange={handleChange} placeholder={"Дата отзыва"}*/}
                    {/*              width={"150px"} name={"date"} values={values} handleSubmit={handleSubmit} handleClear={handleClear}/>*/}
                    Дата: <CustomDatePicker handleSubmit={handleSubmit} field={"created_date"}
                                            setFieldValue={setFieldValue}/>
                </div>

            </div>

            <div>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={
                        feedbackCount || 0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage=""
                    sx={{marginBottom: "10px"}}
                />
            </div>

        </Box>
    )

    return (
        <>
            <SearchComponent children={children}/>
            <ReviewList rowsPerPage={rowsPerPage}/>
        </>
    );
};

export default Review;